module.exports = __webpack_public_path__ + "img/zc.b4b473f3.png";